// extracted by mini-css-extract-plugin
module.exports = {"container":"SearchPriceOffers_container__2zFY5","frame":"SearchPriceOffers_frame__1J1zm","spin":"SearchPriceOffers_spin__2GL38"};